// Configuration file for environment variables

const config = {
  env: process.env.REACT_APP_ENV || 'local',
  siteUrl: process.env.REACT_APP_SITE_URL || 'http://localhost:3000',
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
  siteName: process.env.REACT_APP_SITE_NAME || 'AURA Ayurveda & Wellness',
  contact: {
    email: process.env.REACT_APP_CONTACT_EMAIL || 'auraayurvedaandw@gmail.com',
    phone: process.env.REACT_APP_CONTACT_PHONE || '+91 7086453209 ',
    whatsapp: process.env.REACT_APP_WHATSAPP || '+91 6000503903',
    landline: process.env.REACT_APP_LANDLINE || '+91 8011110269',
  },
  isProduction: process.env.REACT_APP_ENV === 'production',
  isDevelopment: process.env.REACT_APP_ENV === 'local',
};

export default config;
